import React from 'react';
import { FiBookOpen, FiMail } from 'react-icons/fi';

export default function Footer() {
  return (
    <footer className="border-t border-[#e8edf5] bg-white">
      <div className="mx-auto max-w-7xl px-5 py-12 sm:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">

          {/* Brand */}
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-[var(--brand-accent)] text-white">
                <FiBookOpen className="h-5 w-5" />
              </span>
              <span className="text-base font-bold text-[var(--brand-ink)]">Digital Book Shelf</span>
            </div>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-[var(--text-muted)]">
              Professional subscription management and after-sales support you can trust.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="mb-4 text-xs font-bold uppercase tracking-widest text-[var(--brand-ink)]">Quick Links</h4>
            <ul className="space-y-2.5 text-sm text-[var(--text-muted)]">
              <li><a href="/" className="transition-colors hover:text-[var(--brand-accent)]">Home</a></li>
              <li><a href="/faqs" className="transition-colors hover:text-[var(--brand-accent)]">FAQs</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="mb-4 text-xs font-bold uppercase tracking-widest text-[var(--brand-ink)]">Contact</h4>
            <ul className="space-y-2.5 text-sm text-[var(--text-muted)]">
              <li className="flex items-center gap-2">
                <FiMail className="h-4 w-4 text-[var(--brand-accent)]" />
                support@digitalbookshelfhub.net
              </li>
            </ul>
          </div>

        </div>
      </div>

      <div className="border-t border-[#e8edf5]">
        <div className="mx-auto max-w-7xl px-5 py-4 text-center text-xs text-[var(--text-muted)] sm:px-8">
          &copy; 2026 Digitalbookshelfcare.com — All rights reserved.
        </div>
      </div>
    </footer>
  );
}
